import { FC, useContext, useEffect, useState } from "react";
import { Context } from "../../../index";
import { AppContext } from "../../../App";
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import "./UserMention.css";
import { fullNameFormat } from "../../../helpers/Inicials";
import PersonLineDisplay from "../PersonLineDisplay";
import { isAxiosError } from "axios";
import { IGetAllUsers } from "../../../common/api_interfaces/user/IGetAllUsers";
import { IFullUserInfo } from "../../../common/api_interfaces/user/IUserInfo";
import { UserStatusCode } from "../../../common/enums/userStatus";

export interface IUserMention {
    filter?: string;
    mentionPersons: number[];
    callBack: (user: IFullUserInfo) => void;
    projectId: number;
}

const UserMention: FC<IUserMention> = ({ filter, callBack, mentionPersons, projectId }) => {
    const { store } = useContext(Context);
    const { showToast } = useContext(AppContext);
    const [saveAllUsers, setSaveAllUsers] = useState<IFullUserInfo[]>([]);
    const [allUsers, setAllUsers] = useState<IFullUserInfo[]>([]);

    const fetchData = async () => {
        try {
            const reqBody: IGetAllUsers = {
                projectId: projectId,
                onlyActivated: true,
                statuses: [UserStatusCode.Active],
            };
            let resp = await store.userService.getAllUsers(reqBody);

            const users = resp.data!.filter((user) => {
                if (!mentionPersons.includes(user.id!)) {
                    return user;
                }
            });

            setAllUsers(users!);
            setSaveAllUsers(users!);
        } catch (err) {
            if (isAxiosError(err)) showToast(err.response?.data.message);
        }
    };

    useEffect(() => {
        (async () => {
            await fetchData();
        })();
    }, []);

    useEffect(() => {
        if (filter && filter.length > 0 && filter !== "@") {
            let curfilter = filter.split(" ")[0].toUpperCase();

            setAllUsers(
                saveAllUsers.filter((user) => {
                    const userName = user.name.toUpperCase();
                    const userSurname = user.surname.toUpperCase();
                    const nameMatch = curfilter ? userName.includes(curfilter) : true;
                    const surnameMatch = curfilter ? userSurname.includes(curfilter) : true;

                    return nameMatch || surnameMatch;
                })
            );
        } else {
            (async () => {
                await fetchData();
            })();
        }
    }, [filter]);

    return (
        <div className="user__mention--widget">
            <WidgetContainer style={{ maxHeight: "200px" }}>
                <div style={{ overflowY: "scroll", maxHeight: "175px" }}>
                    {allUsers?.map((user) => (
                        <div
                            id={`${user.id}-user`}
                            className="user__mention--widget__block"
                            onClick={() => callBack(user)}
                        >
                            <PersonLineDisplay
                                style={{ width: "40%" }}
                                name={fullNameFormat(
                                    {
                                        surname: user.surname ?? "",
                                        name: user.name ?? "",
                                        middlename: user.middlename ?? "",
                                    },
                                    "s n m"
                                )}
                                userId={user.id}
                                filter={filter}
                            />
                            <div className="user-mentions-role">{user?.role?.name}</div>
                        </div>
                    ))}
                </div>
            </WidgetContainer>
        </div>
    );
};

export default UserMention;
